export default __webpack_public_path__ + "static/media/travelingDelivery.5705a264.svg";